import { createMachine } from 'xstate';
import { executePayment } from './execute-payment';
import { handleError } from './handle-error';
import { handlePayment } from './handle-payment';

import { createPayload } from './actions';

const paymentMachine = createMachine(
  {
    id: 'verifone-payment',
    initial: 'idle',
    context: {
      config: null,
      request: null,
      response: null,
    },
    states: {
      idle: {
        on: {
          INITIALISE: 'loading',
        },
      },
      loading: {
        entry: ['createPayload'],
        invoke: {
          id: 'verifoneRequest',
          src: executePayment,
          onDone: { target: 'success', actions: ['handlePayment'] },
          onError: {
            target: 'failure',
          },
        },
      },
      success: {
        type: 'final',
      },
      failure: {
        entry: handleError,
        on: {
          RETRY: {
            target: 'loading',
          },
        },
      },
    },
  },
  {
    actions: {
      handleError,
      createPayload,
      executePayment,
      handlePayment,
    },
  },
);

export { paymentMachine };
